// src/components/PlaceOrder.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const PlaceOrder = () => {
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    address: "",
    productId: "",
    totalAmount: "",
  });
  const [message, setMessage] = useState("");

  // Fetch all products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get("https://sonvika.hxbindia.com/api/products");
        if (res.data.success) setProducts(res.data.products);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://sonvika.hxbindia.com/api/orders", formData);
      if (res.data.success) {
        setMessage("✅ Order placed successfully! Check your email for confirmation.");
        setFormData({
          name: "",
          email: "",
          contactNumber: "",
          address: "",
          productId: "",
          totalAmount: "",
        });
      }
    } catch (err) {
      console.error("Order Error:", err);
      setMessage("❌ Failed to place order. Please try again.");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "600px" }}>
      <h2 className="mb-4 text-center">Place an Order</h2>

      {message && (
        <div className={`alert ${message.includes("✅") ? "alert-success" : "alert-danger"}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Full Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Contact Number</label>
          <input
            type="text"
            name="contactNumber"
            className="form-control"
            value={formData.contactNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Address</label>
          <textarea
            name="address"
            className="form-control"
            rows="3"
            value={formData.address}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div className="mb-3">
          <label className="form-label">Select Product</label>
          <select
            name="productId"
            className="form-select"
            value={formData.productId}
            onChange={handleChange}
            required
          >
            <option value="">-- Choose a Product --</option>
            {products.map((product) => (
              <option key={product._id} value={product._id}>
                {product.name} — ₹{product.price}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Total Amount (₹)</label>
          <input
            type="number"
            name="totalAmount"
            className="form-control"
            value={formData.totalAmount}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Place Order
        </button>
      </form>
    </div>
  );
};

export default PlaceOrder;
